<template>
  <div
    class="tabBar"
    :style="{
      background: datas.backColor,
    }"
  >
    <div
      :style="{
        background: datas.backColor,
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <section class="nav_con">
        <template v-if="datas.imageList.length == 0">
          <div v-for="index in 4" :key="index" :class="['nav_item']">
            <img
              v-if="datas.styleType != 1"
              draggable="false"
              :src="defaultImg"
              alt=""
            />
            <div
              v-if="datas.styleType != 2"
              :style="{
                'font-size': datas.wordSize + 'px',
                'font-weight': datas.isBold ? 'bold' : 'normal',
                'font-style': datas.isTilt ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLine ? 'underline' : 'none',
                color: datas.wordColor,
              }"
            ></div>
          </div>
        </template>
        <template v-else>
          <div
            v-for="(item, index) in datas.imageList"
            :key="index"
            :class="[
              { goods_type_item_active: activeTab == index },
              'nav_item',
            ]"
            @click="handleChangeType(index)"
          >
            <img
              v-if="datas.styleType != 1"
              :src="
                index == activeTab
                  ? item.activeImgUrl || defaultImg
                  : item.imgUrl || defaultImg
              "
              alt=""
            />
            <div
              v-if="datas.styleType != 2"
              :style="{
                'font-size':
                  (index == activeTab ? datas.wordSizeActive : datas.wordSize) +
                  'px',
                'font-weight': handleSetBoldStyle(
                  index == activeTab ? datas.isBoldActive : datas.isBold
                ),
                'font-style': handleSetTiltStyle(
                  index == activeTab ? datas.isTiltActive : datas.isTilt
                ),
                'text-decoration': handleSetUnderLineStyle(
                  index == activeTab
                    ? datas.isUnderLineActive
                    : datas.isUnderLine
                ),
                color:
                  index == activeTab ? datas.wordColorActive : datas.wordColor,
              }"
            >
              {{ item.title ? item.title : "" }}
            </div>
          </div>
        </template>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabBar",
  props: {
    datas: Object,
    tabbarIndex: {
      type: [Number],
      default: 0,
    },
  },
  data() {
    return {
      defaultImg: require("@/assets/images/defaultPic2.png"),
      activeTab: this.tabbarIndex,
    };
  },

  computed: {},

  watch: {
    tabbarIndex(val) {
      console.log(val);
      this.activeTab = val;
    },
  },

  created() {
    // const nowName = this.$route.name;
    // const nowPage = this.$route.query.page;
    // if (nowName == "CustomHomePage") {
    //   const findNowIndex = this.datas.imageList.findIndex(
    //     (item) =>
    //       item.linkUrl.split("#")[1] ==
    //       (nowPage == 1
    //         ? "/homePage/homePage"
    //         : nowPage == 2
    //         ? "/homePage/personCenter"
    //         : "")
    //   );
    //   this.activeTab = findNowIndex != -1 ? findNowIndex : 0;
    // }
  },

  mounted() {},

  beforeDestroy() {
    // document.querySelector(".phone-container").style.cssText =
    //   "padding-bottom: 0px";
  },

  methods: {
    handleSetBoldStyle(data) {
      return data ? "bold" : "normal";
    },
    handleSetTiltStyle(data) {
      return data ? "italic" : "normal";
    },
    handleSetUnderLineStyle(data) {
      return data ? "underline" : "none";
    },
    handleChangeType(index) {
      this.activeTab = index;
      // 跳转页面
      const linkData = this.datas.imageList[index].linkUrl;
      if (linkData) {
        window.location.href = linkData;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tabBar {
  width: 100%;
  position: relative;
  position: fixed;
  bottom: 0;
  left: 0px;
  z-index: 2;
  margin: 0 !important;
  padding-bottom: env(safe-area-inset-bottom);
  .nav_con {
    display: flex;
    .nav_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      img {
        margin-bottom: 7px;
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
